import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./components/LandingPage";
import Header from "./components/Header";
import RegisterPage from "./components/RegisterPage";
import ProfilesListPage from "./components/ProfilesListPage";
import ProfileDetailPage from "./components/ProfileDetail/ProfileDetailPage";
import PolicyPage from "./components/PolicyPage";
import AdminPage from "./components/AdminPage";
import AdminLoginPage from "./components/AdminLoginPage";

function AppWrapper() {
  const location = useLocation();

  {
    /* Prevents downloading of images and videos */
  }
  useEffect(() => {
    const blockContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", blockContextMenu);

    return () => {
      document.removeEventListener("contextmenu", blockContextMenu);
    };
  }, []);

  return (
    <>
      <Header pathname={location.pathname} />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/profiles" element={<ProfilesListPage />} />
        <Route path="/profiles/:id" element={<ProfileDetailPage />} />
        <Route path="/policy" element={<PolicyPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin-login" element={<AdminLoginPage />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppWrapper />
      </AuthProvider>
    </Router>
  );
}

export default App;
